export { default as asSetContactDetailsProps } from './asSetContactDetailsProps';
export { default as describeSetContactDetails } from './describeSetContactDetails';
export { default as defaultNewSetContactDetailsProps } from './defaultNewSetContactDetailsProps';
export { default as SetContactDetailsComponent } from './SetContactDetailsComponent';
